<template>
  <div class="filters-page">
      <div class="row">
        <div class="col-md-12">
          <div slot="body">
            <div class="row filters-page__filter-bar-container">
              <filter-bar
                v-model="nombre"
                class="filters-page__filter-bar"
                label="Nombre"
              />
              <filter-bar
                v-model="email"
                class="filters-page__filter-bar"
                label="Email"
              />
              <vuestic-simple-select
                class="filters-page__filter-bar"
                label="City"
                v-model="city"
                :options="cityList"
              />
            </div>
          </div>
          <div class="filters-page__tags">
            <vuestic-tag
              v-if="nombre"
              :name="`Name: ${ nombre }`"
              removable
              @remove="nombre = ''"
            />
            <vuestic-tag
              v-if="email"
              :name="`Email: ${ email }`"
              removable
              @remove="email = ''"
            />
            <vuestic-tag
              v-if="city"
              :name="`City: ${ city }`"
              removable
              @remove="city = ''"
            />
            <span
              v-if="this.city || this.nombre || this.email"
              class="filters-page__clear-all-text"
              @click="clearAll"
            >
              Clear all filters
            </span>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover table-striped first-td-padding">
          <thead style="background: black" >
          <tr style="color: white;">
            <td>Nombre</td>
            <td>Estado</td>
            <td>Acciones</td>
          </tr>
          </thead>
          <tbody>
          <tr v-if="item.estado === 'activo'" v-for="item in filteredItems" v-bind:key="item.email">
            <td>{{ item.nombre }}</td>
            <td>{{item.estado}}</td>
            <td>
              <i @click="" style="margin: 10px" class="fa fa-pencil"></i>
              <i class="fa fa-remove"></i>
            </td>

          </tr>
          </tbody>
        </table>
      </div>
    <vuestic-modal :show.sync="show" v-bind:force="true" ref="staticModal">
      <div slot="title">Editar Transporte</div>
      <form @submit.prevent="editar">
        <div class="form-group">
          <div class="input-group">
            <input type="text" hidden v-model="eId">
            <input type="text" hidden v-model="eEstado">
            <label for="eNombre">Nombre Transporte</label>
            <input autofocus class="edit" id="eNombre" type="text" v-model="eNombre" />
            <i class="bar edit"></i>
          </div>
        </div>
        <vuestic-alert :with-close-btn="true" v-if="successEdit">{{successEdit}}</vuestic-alert>
        <atom-spinner class="spinner" v-if="loading"></atom-spinner>
        <button  class="btn btn-sm btn-info" type="submit">Editar</button>
        <button  @click="modalClose" class="btn btn-sm btn-danger" type="button">Cerrar</button>
      </form>
    </vuestic-modal>
  </div>
</template>

<script>
import VuesticWidget
  from '../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget'
import FilterBar
  from '../../../vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue'
import VuesticSimpleSelect
  from '../../../vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect'
export default {
  name: 'filters',
  components: {
    VuesticWidget, FilterBar, VuesticSimpleSelect
  },
  data () {
    return {
      nombre: '',
      email: '',
      city: '',
      cityList: cityList,
      itemList: itemList,
    }
  },
  methods: {
    clearAll () {
      this.nombre = ''
      this.email = ''
      this.city = ''
    }
  },
  created(){
    this.$store.dispatch('loadTransporte')
  },
  computed: {
    transporte(){
      return this.$store.getters.transportes;
    },
    filteredItems () {
      let filteredItems = this.transporte;
      if (this.nombre) {
        filteredItems = filteredItems.filter(item => item.nombre.toUpperCase()
          .search(this.nombre.toUpperCase()) !== -1)
      }
      if (this.email) {
        filteredItems = filteredItems.filter(item => item.email.toUpperCase()
          .search(this.email.toUpperCase()) !== -1)
      }
      if (this.city) {
        filteredItems = filteredItems.filter(item => item.city.toUpperCase()
          .search(this.city.toUpperCase()) !== -1)
      }
      return filteredItems
    }
  }
}
</script>

<style lang="scss">
.filters-page {
  &__tags {
    display: flex;
  }
  &__filter-bar {
    width: 300px;
  }
  &__filter-bar-container {
    margin: 0;
    justify-content: space-between;
  }
  &__table-heading {
    color: $vue-green
  }
  &__collapse {
    .vuestic-collapse__body {
      background-color: white;
    }
  }
  &__clear-all-text {
    cursor: pointer;
    color: $vue-green;
    margin-top: 0.3rem;
  }
}
</style>
